import script from "./BaseWidget.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseWidget.vue?vue&type=script&lang=ts&setup=true"

import "./BaseWidget.vue?vue&type=style&index=0&id=c21e6ae2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.5.17_webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c21e6ae2"]])

export default __exports__